import styled from "styled-components";

export const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 48px;
  padding: 0 24px;
  background: linear-gradient(90deg, #f4ecfe 0%, #faf5f2 100%);
  border: 1px solid #ffffff;
  border-radius: 8px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    padding: 10px 16px;
    border-radius: 0;
    text-align: center;
  }
`;

export const BannerMessage = styled.span`
  font-family: "Mona Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: #000e2a;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const UpgradeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 125px;
  height: 32px;
  padding: 0 20px;
  background: linear-gradient(90deg, #2266ef 0%, #6c2ef2 100%);
  color: #ffffff;
  font-family: "Mona Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 14px;
  font-weight: 700;
  border: none;
  border-radius: 32px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    opacity: 0.95;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
